"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
Object.defineProperty(exports, "__esModule", { value: true });
var Either_1 = require("./Either");
var MaybeAsync_1 = require("./MaybeAsync");
var helpers = {
    liftEither: function (either) {
        if (either.isLeft()) {
            throw either.__value;
        }
        return Promise.resolve(either.__value);
    },
    fromPromise: function (promise) {
        return promise.then(helpers.liftEither);
    },
    throwE: function (error) {
        throw error;
    }
};
var EitherAsyncImpl = /** @class */ (function () {
    function EitherAsyncImpl(runPromise) {
        this.runPromise = runPromise;
    }
    EitherAsyncImpl.prototype.run = function () {
        return __awaiter(this, void 0, void 0, function () {
            var _a, e_1;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        _b.trys.push([0, 2, , 3]);
                        _a = Either_1.Right;
                        return [4 /*yield*/, this.runPromise(helpers)];
                    case 1: return [2 /*return*/, _a.apply(void 0, [_b.sent()])];
                    case 2:
                        e_1 = _b.sent();
                        return [2 /*return*/, Either_1.Left(e_1)];
                    case 3: return [2 /*return*/];
                }
            });
        });
    };
    EitherAsyncImpl.prototype.map = function (f) {
        var _this = this;
        return exports.EitherAsync(function (helpers) { return _this.runPromise(helpers).then(f); });
    };
    EitherAsyncImpl.prototype.mapLeft = function (f) {
        var _this = this;
        return exports.EitherAsync(function (helpers) { return __awaiter(_this, void 0, void 0, function () {
            var e_2;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        _a.trys.push([0, 2, , 3]);
                        return [4 /*yield*/, this.runPromise(helpers)];
                    case 1: return [2 /*return*/, _a.sent()];
                    case 2:
                        e_2 = _a.sent();
                        throw f(e_2);
                    case 3: return [2 /*return*/];
                }
            });
        }); });
    };
    EitherAsyncImpl.prototype.chain = function (f) {
        var _this = this;
        return exports.EitherAsync(function (helpers) { return __awaiter(_this, void 0, void 0, function () {
            var value;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.runPromise(helpers)];
                    case 1:
                        value = _a.sent();
                        return [2 /*return*/, helpers.fromPromise(f(value).run())];
                }
            });
        }); });
    };
    EitherAsyncImpl.prototype.chainLeft = function (f) {
        var _this = this;
        return exports.EitherAsync(function (helpers) { return __awaiter(_this, void 0, void 0, function () {
            var e_3;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        _a.trys.push([0, 2, , 3]);
                        return [4 /*yield*/, this.runPromise(helpers)];
                    case 1: return [2 /*return*/, _a.sent()];
                    case 2:
                        e_3 = _a.sent();
                        return [2 /*return*/, helpers.fromPromise(f(e_3).run())];
                    case 3: return [2 /*return*/];
                }
            });
        }); });
    };
    EitherAsyncImpl.prototype.toMaybeAsync = function () {
        var _this = this;
        return MaybeAsync_1.MaybeAsync(function (_a) {
            var liftMaybe = _a.liftMaybe;
            return __awaiter(_this, void 0, void 0, function () {
                var either;
                return __generator(this, function (_b) {
                    switch (_b.label) {
                        case 0: return [4 /*yield*/, this.run()];
                        case 1:
                            either = _b.sent();
                            return [2 /*return*/, liftMaybe(either.toMaybe())];
                    }
                });
            });
        });
    };
    EitherAsyncImpl.prototype['fantasy-land/map'] = function (f) {
        return this.map(f);
    };
    EitherAsyncImpl.prototype['fantasy-land/chain'] = function (f) {
        return this.chain(f);
    };
    return EitherAsyncImpl;
}());
/** Constructs an EitherAsync object from a function that takes an object full of helpers that let you lift things into the EitherAsync context and returns a Promise */
exports.EitherAsync = function (runPromise) { return new EitherAsyncImpl(runPromise); };
/** Constructs an EitherAsync object from a function that returns an Either wrapped in a Promise */
exports.fromPromise = function (f) { return exports.EitherAsync(function (_a) {
    var fP = _a.fromPromise;
    return fP(f());
}); };
/** Constructs an EitherAsync object from a function that returns a Promise. The left type is defaulted to the built-in Error type */
exports.liftPromise = function (f) { return exports.EitherAsync(f); };
/** Constructs an EitherAsync object from an Either */
exports.liftEither = function (either) {
    return exports.EitherAsync(function (_a) {
        var liftEither = _a.liftEither;
        return liftEither(either);
    });
};
